// src/components/income/IncomeHeader.tsx
import React from 'react';
import { Plus, Wallet, RefreshCw } from 'lucide-react';

interface IncomeHeaderProps {
  totalIncome: number;
  recordCount: number;
  apiLoading: boolean;
  onAdd: () => void;
  formatCurrency: (value: number | string) => string;
}

const IncomeHeader: React.FC<IncomeHeaderProps> = ({ totalIncome, recordCount, apiLoading, onAdd, formatCurrency }) => {
  return (
    <>
      {/* Desktop Header */}
      <div className="hidden md:block">
        <div className="p-4 md:p-6 text-black">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
            <div className="flex gap-3">
              <div className="bg-blue-600 text-white p-3 md:p-4 rounded-full">
                <Wallet className="w-6 h-6 md:w-8 md:h-8" />
              </div>
              <div>
                <h2 className="text-2xl md:text-3xl font-medium mt-2 mb-2">
                  Income / <span className="text-lg font-bold">{formatCurrency(totalIncome)}</span>
                </h2>
                <div className="flex items-center gap-2 text-sm">
                  <span>{recordCount} records</span>
                  {apiLoading && <RefreshCw className="w-4 h-4 animate-spin" />}
                </div>
              </div>
            </div>
            <div className="flex flex-wrap gap-2 md:gap-3">
              <button onClick={onAdd} className="bg-blue-600 text-white py-2 px-4 md:py-3 md:px-6 rounded-lg hover:bg-blue-700 transition-colors duration-200 flex items-center shadow-lg">
                <Plus className="w-4 h-4 md:w-5 md:h-5 mr-2" />
                Add Income
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Mobile Header (You can add the mobile version here if needed) */}
    </>
  );
};

export default IncomeHeader;